import styled from 'styled-components';
import { Button } from 'antd';

export const MetricPanelWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 10px;
`;

export const OverviewWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 4px;
`;

export const HeaderTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #374151;

  .subtitle {
    font-size: 12px;
    color: #999;
    margin: 10px;
  }
`;

export const HeaderSpan = styled.span`
  background-color: #e0e7ff;
  color: #3730a3;
  font-size: 12px;
  margin-left: 5px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const DrilldownIconButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: none;
  background: transparent;
  color: #8c8c8c;
  flex-shrink: 0;

  &:hover {
    color: #1890ff;
    background: rgb(24 144 255 / 10%);
  }

  .anticon {
    font-size: 14px;
  }
`;

export const BodySection = styled.div`
  position: relative;
`;

export const Panel = styled.div`
  display: grid;

  /* Use 1fr to fill width - cards will stretch to fill available space */

  /* For 6 metrics: max column width ensures 3 columns (3x3 layout) */

  /* For 3-5 metrics: cards stretch to fill full width */

  /* For 1 metric: ChartWrapper max-width (420px) prevents over-stretching */
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-auto-rows: 145px;
  gap: 12px;
  justify-items: start;
  place-content: start;
  box-sizing: border-box;
  width: 100%;

  /* Large screens: cap max column width to ensure 6 metrics = 3x3 (max ~450px per column) */
  @media (min-width: 1400px) {
    /* Calculate: for 3 columns with 2 gaps of 14px, max column = (100% - 28px) / 3 */

    /* But we want cards to stretch for 3-5, so use a higher cap that still allows 3 columns for 6 */
    grid-template-columns: repeat(auto-fit, minmax(280px, min(1fr, 450px)));
    gap: 14px;
  }

  /* Medium-large screens: allow stretching, cap to ensure 3 columns for 6 metrics */
  @media (min-width: 1200px) and (max-width: 1399px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, min(1fr, 400px)));
    gap: 12px;
  }

  /* Medium screens: 2-3 columns, full width */
  @media (min-width: 900px) and (max-width: 1199px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 12px;
  }

  /* Tablet: 2 columns, full width */
  @media (min-width: 600px) and (max-width: 899px) {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 10px;
  }

  /* Mobile: single column, full width */
  @media (max-width: 599px) {
    grid-template-columns: 1fr;
    gap: 8px;
    grid-auto-rows: 110px;
  }

  /* Ensure cards fill their grid cell */

  /* ChartWrapper max-width (420px) prevents single cards from stretching too much */
  & > * {
    width: 100%;
    max-width: 100%;
  }
`;
